import { Component, createRef } from "react";
import {
  Card,
  Form,
  Button,
  Row,
  Col,
  Modal,
} from "react-bootstrap";
import api from "../../services/api";
import { withRouter } from "../../common/with-router";
import { generateUniqueColor } from "../../common/utils";
import AsyncSelect from "react-select/async";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

class PrestadoresEdit extends Component {
  constructor(props) {
    super(props);

    this.calendarRef = createRef();
    this.draggableInitialized = false;
    this.today = new Date().toISOString().split("T")[0];

    this.state = {
      cliente_id: "",
      cliente_nome: "",
      programa_id: "",
      programa_nome: "",
      servico_procedimento_id: "",
      servico_procedimento_nome: "",
      servicos: [],
      permite_editar: true,
      showModalAgendamento: false,
      addProgramacaoForm: {},
      events: [],
      selected_program: "",
      agendamentoEdit: false,
      loading: false,
    };
  }

  componentDidMount() {
    document.body.classList.add('sb-sidenav-toggled');
    this.carregaServicoProcedimento();
    this.initializeDraggable();
  }

  initializeDraggable = () => {
    if (this.draggableInitialized) return;
    // Inicializa os elementos como arrastáveis
    this.draggableInitialized = true; // Evita recriar o objeto Draggable
    new Draggable(document.getElementById("external-events"), {
      itemSelector: ".fc-event",
      eventData: function (eventEl) {
        return {
          title: eventEl.getAttribute("title"), // Recupera o título
          id: eventEl.getAttribute("data-id"), // ID personalizado
          color: eventEl.getAttribute("data-color"), // Cor
        };
      },
    });
    this.carregarEventos();
  }

  carregarEventos = () => {
    // eslint-disable-next-line react/prop-types
    const id = this.props.router.params.id;
    api
      .get(`/agenda/events/${id}`)
      .then((response) => {
        const dados = []
        response.data.map((event, index) => {
          const service_id = event.service?.id
          const serviceName = this.state.servicos.find((service) => service.id === service_id);
          const data = {
            title: serviceName.label,
            color: generateUniqueColor(serviceName.label),
            ...event,
          }
          if (data.recurrence) {
            const dataInicio = new Date(event.datetime_start);
            const dataFinal = new Date(event.datetime_end);
            const diff = dataFinal.getTime() - dataInicio.getTime();
            const diffDays = diff / (1000 * 3600 * 24);
            const recurrenceWeekDay = dataInicio.getDay()

            Array.from({ length: diffDays + 1 }, (_, i) => {
              const newDate = new Date(dataInicio);
              newDate.setDate(newDate.getDate() + i);
              let formatedDate = newDate.toISOString().replace(".000Z", "").split("T")[0];
              formatedDate = `${formatedDate}T00:00:00`
              if (newDate.getDay() === recurrenceWeekDay) {
                dados.push({
                  start: formatedDate,
                  end: formatedDate,
                  weekday: recurrenceWeekDay,
                  id: i,
                  ...data,
                });
              }
            });
          } else {
            dados.push({
              start: event.datetime_start,
              end: event.datetime_end,
              id: index + 1,
              ...data,
            });
          }
        })
        this.setState({ events: dados });
      })
      .catch(() => {
      });
  }

  carregaClientes = async (inputValue) => {
    try {
      const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
      const opcoes = response.data.results.map((cliente) => ({
        value: cliente.id,
        label: cliente.dados_pessoa.razao_social
          ? `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
          : cliente.dados_pessoa.nome,
      }));
      return opcoes;
    } catch (error) {
      console.error("Erro ao carregar clientes:", error);
      return [];
    }
  };

  carregaProgramas = async (inputValue) => {
    if (!this.state.cliente_id) {
      return [];
    }
    try {
      const response = await api.get(
        `/programas/?nome=${inputValue}&cliente_id=${this.state.cliente_id}`
      );
      const opcoes = response.data.results.map((programa) => ({
        value: programa.id,
        label: programa.nome,
      }));
      return opcoes;
    } catch (error) {
      console.error("Erro ao carregar programas:", error);
      return [];
    }
  };

  carregaServicoProcedimento = async () => {
    try {
      const response = await api.get(
        `/servicos_procedimentos/?nome=`
      );
      const opcoes = response.data.results.map((servico) => ({
        id: servico.id,
        value: servico.id,
        label: servico.nome,
        color: generateUniqueColor(servico.nome),
      }));
      this.setState({ servicos: opcoes });
    } catch (error) {
      console.error("Erro ao carregar serviço/procedimento:", error);
      return [];
    }
  };

  handleShowModalAgendamento = (scheduleInfo) => {
    const id = scheduleInfo.draggedEl.getAttribute("data-id");
    const weekday = scheduleInfo.date.getDay();
    const newDate = new Date(scheduleInfo.date)
      .toISOString()
      .replace(":00.000Z", "").split("T")[0];
    this.setState({
      showModalAgendamento: true,
      addProgramacaoForm: {
        ...this.state.addProgramacaoForm,
        datetimeStart: newDate,
        datetimeEnd: newDate,
        serviceId: id,
        weekday: weekday,
        recurrence: false,
      },
    });
    setTimeout(() => {
      this.calendarRef.current
        .getApi()
        .getEventById(id)
        .remove();
    }, 1000);
  };

  handleCloseModalAgendamento = () => {
    this.setState({ showModalAgendamento: false });
    this.clearAddProgramacaoForm();
  };

  handleCheckRecorrencia = (e) => {
    this.setState({
      addProgramacaoForm: {
        ...this.state.addProgramacaoForm,
        recurrence: e.target.checked,
      },
    });
  };

  handleEventClick = (info) => {
    const id = parseInt(info.event.id);
    if (!id) return;
    const event = this.state.events.filter((event) => event.id === id);
    if (!event[0]) return;
    const start = new Date(event[0].datetime_start)
      .toISOString()
      .replace(":00.000Z", "").split("T")[0];
    const end = new Date(event[0].datetime_end)
      .toISOString()
      .replace(":00.000Z", "").split("T")[0];
    const recurrence = event[0].recurrence;
    this.setState({
      showModalAgendamento: true,
      agendamentoEdit: true,
      addProgramacaoForm: {
        ...event[0],
        datetimeStart: start,
        datetimeEnd: recurrence ? end : start,
      },
    })
  };

  handleAdicionarProgramacao = () => {
    this.setState({ loading: true });
    const url = this.state.addProgramacaoForm.id
      ? "/agenda/event/" + this.state.addProgramacaoForm.id + "/"
      : "/agenda/event/";
    const metodo = this.state.addProgramacaoForm.id ? "put" : "post";

    // eslint-disable-next-line react/prop-types
    const prestadorId = this.props.router.params.id;
    const MySwal = withReactContent(Swal);

    const formData = {
      prestadorId: prestadorId,
      clienteId: this.state.cliente_id,
      recurrenceEnd: this.state.addProgramacaoForm.recurrence ? this.state.addProgramacaoForm.datetimeEnd : null,
      ...this.state.addProgramacaoForm,
    }
    api({
      method: metodo,
      url: url,
      data: formData,
    })
      .then(() => {
        MySwal.fire({
          title: this.state.addProgramacaoForm.id ? "Evento Editado" : "Evento Criado",
          icon: "success",
          html: this.state.addProgramacaoForm.id ? "Evento alterado com sucesso" : "Evento criado com sucesso",
          showCloseButton: true,
        })
        this.carregarEventos();
      }).catch(() => {
        const erro_msg =
          "Erro ao cadastrar o evento, verifique os campos e tente novamente";
        MySwal.fire({
          icon: "error",
          showCloseButton: true,
          title: <p>{erro_msg}</p>,
        });
      }).finally(() => {
        this.setState({ loading: false });
        this.clearAddProgramacaoForm();
        this.handleCloseModalAgendamento();
      });
  };

  handleChangeProgramacaoData = (e, campo) => {
    this.setState({
      addProgramacaoForm: {
        ...this.state.addProgramacaoForm,
        [campo]: e.target.value,
      },
    });
  };

  handleDeleteProgramacao = () => {
    const MySwal = withReactContent(Swal);
    this.setState({ loading_delete: true });
    api({
      method: 'DELETE',
      url: `/agenda/event/${this.state.addProgramacaoForm.id}/delete`,
      data: {
        recurrenceReplicate: this.state.addProgramacaoForm.recurrence,
      },
    }).then(() => {
      MySwal.fire({
        title: "Evento deletado",
        icon: "success",
        html: "Evento deletado com sucesso",
        showCloseButton: true,
      })
      this.carregarEventos();
      this.calendarRef.current
        .getApi()
        .getEventById(this.state.addProgramacaoForm.id)
        .remove();
    }).catch(() => {
      const erro_msg =
        "Erro ao deletar o evento, tente novamente mais tarde";
      MySwal.fire({
        icon: "error",
        showCloseButton: true,
        title: <p>{erro_msg}</p>,
      });
    })
      .finally(() => {
        this.clearAddProgramacaoForm();
        this.handleCloseModalAgendamento();
        this.setState({ loading_delete: false });
      });
  }

  clearAddProgramacaoForm = () => {
    this.setState({
      agendamentoEdit: false,
      addProgramacaoForm: {},
    });
  };

  handleChange = (event, fieldName) => {
    this.setState({
      [`${fieldName}_id`]: event.value,
      [`${fieldName}_nome`]: event.label,
    });
  }

  render() {
    if (this.state.loading) {
      return;
    }

    if (!this.state.permite_editar) {
      return (
        <div>
          <Row className="align-items-center">
            <Col sm={12}>
              <h5 className="page-title">
                Vocẽ não tem permissão para acessar essa página
              </h5>
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <div>
        <Row className="align-items-center">
          <Col sm={6} lg={6}>
            <h4 className="page-title">{this.state.titulo_pagina}</h4>
          </Col>
        </Row>
        <Card className="cardDestaque">
          <Card.Body>
            <Row>
              <Col sm={8} xs={12}>
                <FullCalendar
                  ref={this.calendarRef}
                  locale={"pt-br"}
                  plugins={[dayGridPlugin, interactionPlugin]}
                  validRange={{
                    start: new Date().toISOString().split('T')[0], // Desabilita datas passadas
                  }}
                  headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth",
                  }}
                  initialView="dayGridMonth"
                  droppable={true}
                  editable={false}
                  drop={(info) => {
                    this.handleShowModalAgendamento(info);
                  }}
                  eventClick={(info) => {
                    this.handleEventClick(info);
                  }}
                  events={this.state.events}
                />
              </Col>
              <Col sm={4} xs={12}>
                <Row>
                  <Col sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Cliente</Form.Label>
                      <AsyncSelect
                        required
                        cacheOptions
                        loadOptions={this.carregaClientes}
                        defaultOptions
                        name="cliente_id"
                        placeholder={"Buscar cliente..."}
                        noOptionsMessage={() => "Nenhum cliente encontrado"}
                        onChange={(e) => this.handleChange(e, "cliente")}
                        value={
                          this.state.cliente_id
                            ? {
                              value: this.state.cliente_id,
                              label: this.state.cliente_nome,
                            }
                            : null
                        }
                      />
                    </Form.Group>
                  </Col>
                  {this.state.cliente_id && (
                    <Col sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Programa</Form.Label>
                        <AsyncSelect
                          key={`programa-${this.state.cliente_id}`}
                          required
                          cacheOptions
                          loadOptions={this.carregaProgramas}
                          defaultOptions
                          name="programa_id"
                          placeholder={"Buscar programa..."}
                          noOptionsMessage={() =>
                            "Nenhum programa encontrado"
                          }
                          onChange={(e) => this.handleChange(e, "programa")}
                          value={
                            this.state.programa_id
                              ? {
                                value: this.state.programa_id,
                                label: this.state.programa_nome,
                              }
                              : null
                          }
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <Row style={{ display: this.state.programa_id ? '' : 'none' }}>
                  <Col sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Serviços</Form.Label>
                      <div id="external-events">
                        {this.state.servicos.map((event) => (
                          <div
                            className="fc-event fc-h-event mb-1 fc-daygrid-event fc-daygrid-block-event p-2"
                            title={event.label}
                            data-id={event.id}
                            data-color={event.color}
                            data-custom={event.custom}
                            key={'event-' + event.id}
                            style={{
                              backgroundColor: event.color,
                              borderColor: event.color,
                              cursor: "pointer",
                            }}
                          >
                            <div className="fc-event-main">
                              <div>
                                <strong>{event.label}</strong>
                              </div>
                              {event.custom}
                            </div>
                          </div>
                        ))}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Modal
          show={this.state.showModalAgendamento}
          onHide={this.handleCloseModalAgendamento}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.agendamentoEdit
                ? "Editar programação"
                : "Adicionar programação"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Horário</Form.Label>
                  <Form.Control
                    as="select"
                    value={this.state.addProgramacaoForm.horario}
                    onChange={(e) =>
                      this.handleChangeProgramacaoData(e, "horario")
                    }
                  >
                    <option defaultValue="" selected disabled>Selecione um horário</option>
                    <option value={"08:00"}>08:00</option>
                    <option value={"09:00"}>09:00</option>
                    <option value={"10:00"}>10:00</option>
                    <option value={"11:00"}>11:00</option>
                    <option value={"12:00"}>12:00</option>
                    <option value={"13:00"}>13:00</option>
                    <option value={"14:00"}>14:00</option>
                    <option value={"15:00"}>15:00</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col sm={6} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Duração</Form.Label>
                  <Form.Control
                    as="select"
                    value={this.state.addProgramacaoForm.duracao}
                    onChange={(e) =>
                      this.handleChangeProgramacaoData(e, "duracao")
                    }
                  >
                    <option defaultValue="" selected disabled>Selecione a duração</option>
                    <option value={30}>30 minutos</option>
                    <option value={60}>1 hora</option>
                    <option value={90}>1 hora e 30 minutos</option>
                    <option value={120}>2 horas</option>
                    <option value={160}>2 horas e 30 minutos</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col sm={12} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Adicionar recorrência para essa programação?
                  </Form.Label>
                  <Form.Check // prettier-ignore
                    type="switch"
                    id="custom-switch"
                    checked={!!this.state.addProgramacaoForm.recurrence}
                    onChange={this.handleCheckRecorrencia}
                  />
                </Form.Group>
              </Col>

              {!!this.state.addProgramacaoForm.recurrence && (
                <>
                  <Col sm={12} xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Data de início</Form.Label>
                      <Form.Control
                        type="date"
                        name="agendamento_data_inicio"
                        required
                        placeholder="Data de início"
                        min={this.today}
                        value={this.state.addProgramacaoForm.datetimeStart}
                        onChange={(e) =>
                          this.handleChangeProgramacaoData(e, "datetimeStart")
                        }
                      />
                    </Form.Group>
                  </Col>

                  <Col sm={12} xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Data da término</Form.Label>
                      <Form.Control
                        type="date"
                        name="agendamento_data_termino"
                        required
                        placeholder="Data de término"
                        min={this.today}
                        value={this.state.addProgramacaoForm.datetimeEnd}
                        onChange={(e) =>
                          this.handleChangeProgramacaoData(e, "datetimeEnd")
                        }
                      />
                    </Form.Group>
                  </Col>
                </>
              )}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            {!this.state.agendamentoEdit && (
              <Button
                variant="secondary-outline"
                onClick={this.handleCloseModalAgendamento}
              >
                Fechar
              </Button>
            )}
            {this.state.agendamentoEdit && (
              <Button
                variant="danger"
                onClick={() => this.handleDeleteProgramacao()}
              >
                {this.state.loading_delete ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  <span>Excluir programação</span>
                )}
              </Button>
            )}
            <Button variant="primary" onClick={this.handleAdicionarProgramacao} disabled={this.state.loading}>
              {this.state.loading ? (
                <span className="spinner-border spinner-border-sm"></span>
              ) : (
                <span>
                  {this.state.agendamentoEdit
                    ? "Salvar programação"
                    : "Adicionar programação"}
                </span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default withRouter(PrestadoresEdit);
